import PropTypes from 'prop-types'
import React from 'react'

export default function IconSubjects({ className }) {
  return (
    <span
      className={`${className} main-icon-container main-icon-container-subjects`}
    >
      <svg
        className="main-icon main-icon-subjects"
        viewBox="0 0 80 80"
        enableBackground="new 0 0 80 80"
      >
        <path d="M17.864,21.692h3.488l9.8,23.188h-3.621l-2.358-5.847H13.812l-2.358,5.847H7.965L17.864,21.692z
  M19.492,24.815l-4.618,11.493h9.235L19.492,24.815z"
        />
        <path d="M33.993,37.752h6.277c1.196,0,2.298,0.104,3.306,0.314c1.008,0.211,1.865,0.548,2.575,1.014
  c0.708,0.465,1.262,1.067,1.661,1.812c0.399,0.74,0.599,1.644,0.599,2.706c0,1.595-0.432,2.817-1.296,3.671
  c-0.863,0.853-2.027,1.468-3.488,1.844v0.066c0.796,0.066,1.522,0.245,2.175,0.531c0.653,0.288,1.218,0.67,1.694,1.146
  c0.476,0.478,0.847,1.04,1.113,1.694c0.266,0.652,0.398,1.39,0.398,2.209c0,1.241-0.238,2.259-0.714,3.056
  c-0.477,0.799-1.118,1.43-1.927,1.894c-0.809,0.466-1.75,0.786-2.824,0.964c-1.075,0.178-2.198,0.266-3.372,0.266h-6.178V37.752z
  M37.314,47.65h1.827c0.798,0,1.556-0.033,2.276-0.099c0.72-0.066,1.351-0.228,1.894-0.481c0.542-0.255,0.974-0.626,1.295-1.114
  c0.321-0.486,0.481-1.162,0.481-2.025c0-0.688-0.132-1.252-0.398-1.695c-0.267-0.442-0.609-0.796-1.03-1.062
  c-0.421-0.265-0.88-0.449-1.378-0.548c-0.499-0.1-0.992-0.15-1.478-0.15h-3.488V47.65z M37.314,58.215h2.491
  c0.753,0,1.473-0.05,2.159-0.15c0.686-0.1,1.291-0.287,1.811-0.564c0.52-0.275,0.936-0.659,1.246-1.145
  c0.31-0.488,0.465-1.119,0.465-1.894c0-0.886-0.177-1.601-0.531-2.143c-0.355-0.544-0.82-0.959-1.396-1.246
  c-0.576-0.289-1.224-0.477-1.943-0.565c-0.72-0.089-1.435-0.133-2.143-0.133h-2.16V58.215z"
        />
        <path d="M67.148,33.479c-1.463-0.864-3.059-1.297-4.785-1.297c-1.328,0-2.541,0.229-3.638,0.682
  c-1.095,0.453-2.036,1.087-2.823,1.895s-1.391,1.766-1.811,2.873c-0.421,1.108-0.631,2.313-0.631,3.621
  c0,1.373,0.227,2.612,0.681,3.72c0.453,1.108,1.079,2.06,1.877,2.857c0.798,0.797,1.729,1.412,2.79,1.844
  c1.063,0.431,2.193,0.647,3.389,0.647c0.42,0,0.864-0.027,1.328-0.083c0.465-0.055,0.925-0.134,1.379-0.232
  c0.453-0.101,0.887-0.217,1.297-0.349c0.408-0.134,0.757-0.288,1.047-0.465l0.197,3.222c-0.885,0.376-1.813,0.608-2.79,0.698
  c-0.975,0.088-1.805,0.133-2.491,0.133c-1.839,0-3.511-0.282-5.017-0.848c-1.506-0.564-2.79-1.373-3.853-2.425
  c-1.063-1.052-1.889-2.326-2.475-3.82c-0.588-1.494-0.881-3.162-0.881-5c0-1.794,0.304-3.421,0.914-4.882
  c0.61-1.463,1.461-2.714,2.557-3.756c1.097-1.04,2.393-1.844,3.888-2.408s3.128-0.847,4.899-0.847c0.908,0,1.793,0.073,2.658,0.217
  c0.862,0.144,1.716,0.404,2.558,0.781L67.148,33.479z"
        />
      </svg>
      <span>Schulfach</span>
    </span>
  )
}

IconSubjects.propTypes = {
  className: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/frontend/base/components/IconSubjects.js